module.exports = __webpack_public_path__ + "static/media/tOrdersSim.1e5248ae.png";